import Vue from 'vue';

const getInitialState = () => ({
  collections: {},
  navDrawer: false,
});

export const getters = {};

export const mutations = {
  setNavDrawer(state, { open }) {
    state.navDrawer = open;
  },
  addCollection(state, { collection }) {
    Vue.set(state.collections, collection.name, collection);
  },
  removeCollection(state, { collection }) {
    Vue.delete(state.collections, collection.name);
  },
  resetState(state) {
    Object.assign(state, getInitialState());
  },
};

export const actions = {};

export default {
  mutations,
  actions,
  getters,
  namespaced: true,
  state: getInitialState,
};
